import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AIONZ_TOOLTIP_DATA } from '@aionzdev/design-system';
import { CollapsedSupplierSummary } from '../../../interfaces/collapsed-supplier-summary';

/** Tooltip da coluna recolhida: a proposta do fornecedor em resumo, item a item, sem reabrir a coluna. */
@Component({
  selector: 'aionz-collapsed-supplier-tooltip',
  imports: [CurrencyPipe, DatePipe, MatIconModule],
  templateUrl: './collapsed-supplier-tooltip.component.html',
  styleUrl: './collapsed-supplier-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollapsedSupplierTooltipComponent {
  protected readonly data = inject(AIONZ_TOOLTIP_DATA) as CollapsedSupplierSummary;

  protected lineTotal(price: number | null, quantity: number): number | null {
    return price == null ? null : price * quantity;
  }
}
